import { useEffect, useState } from "react";
import api, { catIcon } from "../lib/api";
import { useNavigate } from "react-router-dom";
import AddBillDialog from "../components/AddBillDialog";
import { Button } from "../components/ui/button";
import { Plus } from "lucide-react";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [addOpen, setAddOpen] = useState(false);
  const [preselected, setPreselected] = useState(null);

  const load = () => api.get("/categories").then((r) => setCategories(r.data));
  useEffect(() => { load(); }, []);

  const open = (c) => { if (c.coming_soon) return; setPreselected(c); setAddOpen(true); };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900">Categories</h1>
          <p className="text-slate-500 mt-1">Everything you can pay and save on.</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {categories.map((c) => {
          const Icon = catIcon(c.icon);
          return (
            <button key={c.slug} onClick={() => open(c)} disabled={c.coming_soon} data-testid={`category-${c.slug}`}
              className={`text-left bg-white rounded-2xl border border-slate-200 p-6 transition-all ${c.coming_soon ? "opacity-60 cursor-default" : "hover:border-emerald-500 hover:shadow-md"}`}>
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${c.coming_soon ? "bg-slate-100" : "bg-emerald-50"}`}>
                <Icon className={`w-6 h-6 ${c.coming_soon ? "text-slate-400" : "text-emerald-600"}`} />
              </div>
              <p className="font-display font-bold text-slate-900 mt-4">{c.name}</p>
              {c.coming_soon ? (
                <span className="inline-block mt-2 text-xs font-bold text-amber-700 bg-amber-50 px-2 py-1 rounded-full">Coming Soon</span>
              ) : (
                <span className="inline-flex items-center gap-1 mt-2 text-xs font-semibold text-emerald-600"><Plus className="w-3.5 h-3.5" /> Add bill</span>
              )}
              {c.subcategories?.length > 0 && <p className="text-xs text-slate-400 mt-2">{c.subcategories.slice(0, 3).join(" · ")}{c.subcategories.length > 3 ? " …" : ""}</p>}
            </button>
          );
        })}
      </div>

      <AddBillDialog open={addOpen} onOpenChange={setAddOpen} categories={categories} preselected={preselected} onSaved={load} />
    </div>
  );
}
